import { useT } from '../../i18n';
import { ProjectPeopleHint } from './TaskCollaboratorsField';

// [Proposition: collaborateurs-tache] Proposals-page tab: what task
// collaborators change, and the project stage where people are added first.
export function CollaboratorsProposal() {
  const { t } = useT();
  return (
    <div>
      <div className="section-label mb-8">{t('collab.whatTitle')}</div>
      <ul className="text-sm text-ink-2 mb-24" style={{ margin: 0, paddingLeft: 'var(--s16)', lineHeight: 1.8 }}>
        <li>{t('collab.what.field')}</li>
        <li>{t('collab.what.reminder')}</li>
        <li>{t('collab.what.card')}</li>
        <li>{t('collab.what.private')}</li>
        <li>{t('collab.what.notify')}</li>
        <li>{t('collab.what.mine')}</li>
      </ul>
      <div className="section-label mb-8" style={{ marginTop: 'var(--s24, 24px)' }}>{t('collab.stepTitle')}</div>
      <p className="text-sm text-ink-2 mb-8">{t('collab.step')}</p>
      <ProjectPeopleHint />
    </div>
  );
}
